<template>
  <!-- <div :style="wrapperStyle" class="d-flex align-items-center">
    <a :style="labelStyle" class="custom-form-label flex-shrink-zero">{{ label }}</a>
    <slot></slot>
  </div> -->
  <div :style="wrapperStyle">
    <b-form-group :label-cols="labelCols" label-align="right" :label="label">
      <slot></slot>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    labelCols: {
      type: [String, Number],
      default: 5,
    },
    width: [String, Number],
    labelMarginLeft: {
      type: [String, Number],
      default: 0,
    },
    labelMarginRight: {
      type: [String, Number],
      default: 8,
    }
  },
  data() {
    return {
      wrapperStyle: {
        width: `${this.width}px`,
      },
      labelStyle: {
        marginLeft: `${this.labelMarginLeft}px`,
        marginRight: `${this.labelMarginRight}px`
      },
    }
  }
}
</script>